import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class WinLine {
	protected _index: number;
	protected _symbol: number;
	protected _positions: SymbolPosition[] = [];
	protected _winPositions: SymbolPosition[] = [];
	protected _win: number;

	constructor(index: number, symbol: number, positions: SymbolPosition[], winPositions: SymbolPosition[], win: number) {
		this._index = index;
		this._symbol = symbol;
		this._positions = positions;
		this._winPositions = winPositions;
		this._win = win;
	}

	public get index(): number {
		return this._index;
	}

	public get positions(): SymbolPosition[] {
		return this._positions;
	}

	public get winPositions(): SymbolPosition[] {
		return this._winPositions;
	}

	public get symbol(): number {
		return this._symbol;
	}

	public get win(): number {
		return this._win;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/WinLine.ts